export const SIDE_FILTER_CATEGORIES = {
  dateTime: "DateTimeFilters"
};
